import { render } from "./UploadDocument.vue?vue&type=template&id=435fef85&scoped=true"
import script from "./UploadDocument.vue?vue&type=script&lang=ts"
export * from "./UploadDocument.vue?vue&type=script&lang=ts"

import "./UploadDocument.vue?vue&type=style&index=0&id=435fef85&lang=sass&scoped=true"
script.render = render
script.__scopeId = "data-v-435fef85"

export default script